import { FiFileText, FiGrid } from 'react-icons/fi';
import React, { ReactElement } from 'react';

export const ExportFormat = {
  CSV: 'csv',
  XLSX: 'xlsx',
} as const;

export type ExportFormatType = (typeof ExportFormat)[keyof typeof ExportFormat];

export const DEFAULT_EXPORT_FORMAT: ExportFormatType[] = [ExportFormat.CSV];
export const FULL_EXPORT_FORMATS: ExportFormatType[] = [ExportFormat.CSV, ExportFormat.XLSX];


interface ExportType {
  label: string;
  value: ExportFormatType;
  icon: ReactElement;
}

export const EXPORT_TYPES: ExportType[]= [
  { label: 'CSV', value: ExportFormat.CSV, icon: <FiFileText fontSize="1.5rem" stroke={"gray"}/> },
  { label: 'Excel (.xlsx)', value: ExportFormat.XLSX, icon: <FiGrid  fontSize="1.5rem" stroke={"gray"}/> }
];
